import {type TextareaHTMLAttributes, forwardRef, useId} from 'react';
import {cn} from '../../lib/cn';

export type LegacyTextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label?: string;
  invalid?: boolean;
  maxLength?: number;
  textareaClassName?: string;
};

/**
 * @deprecated
 */
export const LegacyTextarea = forwardRef<HTMLTextAreaElement, LegacyTextareaProps>(
  (
    {className, textareaClassName, label, disabled, name, invalid, ...textareaProps},
    ref,
  ) => {
    const inputId = useId();

    return (
      <div className={cn('relative', className)}>
        <textarea
          ref={ref}
          id={inputId}
          name={name}
          disabled={disabled}
          className={cn(
            'peer box-border min-h-[120px] w-full resize-none rounded-lg border border-[var(--chekin-neutral-300)] bg-[var(--chekin-neutral-50)] px-4 py-3 text-[var(--chekin-blue-900)] outline-none [scrollbar-color:#777e91_transparent] [scrollbar-gutter:stable] placeholder:text-[var(--chekin-neutral-600)] placeholder:opacity-100 focus:border-[var(--chekin-blue-500)] focus:bg-white focus:transition-colors focus:duration-100 focus:ease-in-out [&:not(:placeholder-shown)]:bg-white',
            invalid &&
              'border-[var(--chekin-red-500)] focus:border-[var(--chekin-red-500)]',
            disabled &&
              'cursor-not-allowed resize-none border-[var(--chekin-neutral-500)] bg-[var(--chekin-neutral-50)] text-[var(--chekin-neutral-500)] placeholder:text-[var(--chekin-neutral-500)]',
            textareaClassName,
          )}
          {...textareaProps}
        />
        {label && (
          <label
            htmlFor={inputId}
            className={cn(
              'pointer-events-none absolute left-3 top-4 px-1 text-[var(--chekin-neutral-600)] transition-all duration-100 ease-in-out peer-focus:left-2 peer-focus:top-[-0.6rem] peer-focus:bg-white peer-focus:text-sm peer-focus:font-medium peer-focus:text-[var(--chekin-blue-500)] peer-[:not(:placeholder-shown)]:left-2 peer-[:not(:placeholder-shown)]:top-[-0.6rem] peer-[:not(:placeholder-shown)]:bg-white peer-[:not(:placeholder-shown)]:text-sm peer-[:not(:placeholder-shown)]:font-medium',
              invalid &&
                'text-[var(--chekin-red-500)] peer-focus:text-[var(--chekin-red-500)]',
              disabled && 'text-[var(--chekin-neutral-500)]',
            )}
          >
            {label}
          </label>
        )}
      </div>
    );
  },
);

LegacyTextarea.displayName = 'LegacyTextarea';
